import React, { useMemo, useRef, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import {
  FaTeethOpen,
  FaTooth,
  FaSmileBeam,
  FaTeeth
} from "react-icons/fa";
import { GiFrontTeeth, GiToadTeeth } from "react-icons/gi";
import { LiaTeethOpenSolid, LiaTeethSolid } from "react-icons/lia";
import { TbDental } from "react-icons/tb";
import "./Services.css";

const services = [
  {
    id: 1,
    image:"/img/DSDCard.jpg",
    name: "Diseño de Sonrisa Digital",
    description: `El diseño de sonrisa digital es un proceso que se realiza en un sofware avanzado, en el cual a traves del estudio de las proporciones de tu cara , se establecera el tamaño del ancho y largo de tus nuevos dientes, con el proposito de lograr simetria en el aspecto facial.

                  En este mismo de integra un procedimiento llamado MOCKUP dental, el cual es la replica en una manera analogica de lo planeado en el DSD, este mismo nos permite llevarlo a tus dientes con un material especial para que tengas la oportunidad de visualizar tu sonrisa de manera tridimensional.`
},
  {
    id: 2,
    image: "/img/coronasCard.jpg",
    name: "Coronas",
    description:
      "Una corona dental es una cobertura que se coloca sobre un diente dañado o debilitado para restaurar su forma, tamaño, fuerza y apariencia. Es como una capsula que envuelve todo el diente afectado. Las coronas se utilizan en casos donde un diente está demasiado dañado como para ser reparado con una restauracion  convencional, como cuando está muy desgastado, fracturado, o después de un tratamiento de conductos (endodoncia).",

      features: [
    "Existen diferentes materiales para realizar una corona esta puede ser de Zirconio o bien  ceramica la eleccion de uno u otro se  basara en el sector en donde se colocara.",
    "La longividad de estas restauraciones van de 10-15 años en situaciones adecuadas."
  ],

  },
  {
    id: 4,
     image: "/img/CarillasCard.jpg",
    name: "Carillas Dentales",
    description:
    `En Kaab Dental Experts, diseñamos sonrisas que se integran con tu rostro, tu expresión y tu esencia.

     Nuestras carillas dentales de cerámica o resina se crean con los mejores materiales y laboratorios, cuidando cada detalle de forma, color y proporción para lograr resultados que se ven naturales, elegantes y auténticos.

     Cada tratamiento comienza con un diagnóstico digital de sonrisa, donde analizamos la simetría facial, las líneas estéticas y tu estilo personal. Con una prueba mock-up, puedes visualizar el resultado antes de realizar cualquier cambio definitivo.`,
    features: [
    "Resultados naturales — sonrisa armónica, sin apariencia artificial.",
    "Materiales premium — cerámicas y resinas de última generación.",
    "Planificación digital — precisión y simetría garantizadas.",
    "Mínima invasión — cuidamos la estructura dental original.",
    "Trabajo artesanal — en colaboración con laboratorios de excelencia estética."
  ],

  },
  {
    id: 5,
    image:"img/RestauradoraCard.jpg",
    name: "Odontología restauradora",
    description:
      `Ofrecemos tratamientos odontológicos que se realizan debido a la presencia de caries, las cuales son lesiones destructivas y que dependiendo de la extensión y profundidad de la misma se elegirá tanto el tratamiento adecuado, así como la elección del material restaurador de acuerdo a la función que realizará.

      Las incrustaciones se clasifican en tres grandes tipos, dependiendo del grado de afectación del diente:

      •Inlay. Las cúspides no se cubren.
      •	Onlay. Las cúspides se cubren.
      •	Overlay. Las cúspides que se cubren son tres o más
`
  },
  {
    id: 6,
    image: "/img/ImplanCard.jpg",
    name: "Implantología",
    description:
      `Los implantes dentales son dispositivos de titanio que se colocan en el hueso maxilar o mandibular para reemplazar las raíces de los dientes perdidos. Estos implantes actúan como anclajes para sostener dientes artificiales, como coronas, puentes o prótesis completas, con el fin de restaurar la funcionalidad y estética dental. `,

    features: [
    "1.	Evaluación y planificación: El dentista realiza un examen exhaustivo, haciendo uso de tomografías y radiografias, para evaluar la cantidad y calidad del hueso donde se colocará el implante.",
    "2.	Colocación del implante: En una cirugía ambulatoria, el dentista inserta el implante de titanio en el hueso. El implante actúa como una raíz artificial.",
    "3.	Integración ósea: El implante necesita tiempo para integrarse con el hueso en un proceso llamado osteointegración, este proceso puede tomar de 3 a 6 meses.",
    "4.	Colocación de la corona o prótesis: Una vez que el implante se ha integrado completamente con el hueso, se coloca una corona (o cualquier otro tipo de prótesis) sobre el implante, restaurando la función y estética del diente perdido."
  ],

  advantages: [
    {
      title: "Recuperación rápida",
      description: "En muchos casos, el tiempo de recuperación es más corto que con otros tratamientos de implantes."
    },
    {
      title: "Solución integral",
      description: "Es una opción ideal para pacientes que han perdido todos los dientes en una arcada, ofreciendo una solución funcional y estética."
    },
    {
      title: "Menos invasivo: ",
      description: "Al utilizar solo cuatro ó seis implantes, el tratamiento es menos invasivo que otras opciones que requieren más implantes."
    }
  ]
  },
  {
    id: 7,
    image: "/img/CirugiaCard.jpg",
    name: "Retenedores Vivera",
    description:
      `Los retenedores Vivera, creados por Invisalign, están diseñados con la misma precisión digital que tus alineadores para conservar tu nueva posición dental con
       comodidad y estética.

       Su material es hasta 30% más resistente que los retenedores convencionales, lo que
       garantiza durabilidad y ajuste perfecto.
       Cada juego se fabrica digitalmente a tu medida, asegurando que tu sonrisa se mantenga
       alineada, estable y tan impecable como el primer día`,
    advantages: [
    {
      description: "•	Diseño digital personalizado para máxima precisión."
    },
    {
      description: "• Comodidad y discreción absoluta."
    },
    {
      description: "• Alta resistencia y durabilidad."
    },
    {
      description: "• Reposición fácil y seguimiento Kaab."
    }
  ]
  },

  {
    id: 8,
    image: "/img/AllCard.jpg",
    name: "Blanqueamiento Zoom",
    description:
      `En Kaab Dental Experts, iluminamos tu sonrisa con Zoom®, tratamiento profesional que aclara hasta 7 tonos tu color actual, en una sola sesión.
       Utilizamos tecnología de luz LED avanzada que actúa sobre las moléculas del esmalte sin dañarlo, potenciando el brillo natural de tus dientes de forma rápida, segura y controlada.

      Ideal antes de un evento especial o como complemento a tu tratamiento estético, Zoom te
      brinda resultados visibles desde la primera cita.
      Porque una sonrisa luminosa no solo se nota, se recuerda.`,
    advantages: [
    {
      description: "•	Resultados inmediatos y visibles."
    },
    {
      description: "• Procedimiento seguro y supervisado por especialistas."
    },
    {
      description: "• Cuidado del esmalte y mínima sensibilidad."
    },
    {
      description: "• Ideal para mantenimiento de carillas o Invisalign."
    }
  ]
    },
];

export default function Services() {
  const [selected, setSelected] = useState(null);

  const bookRef = useRef(null);
  const [page, setPage] = useState(0);

  const pages = useMemo(() => {
    if (!selected) return [];

    const out = [];

    // Portada (usamos lo que ya tienes)
    out.push({ type: "cover", title: selected.name, image: selected.image });

    // Descripción (en tu data hay texto con saltos y espacios)
    out.push({
      type: "text",
      title: "Descripción",
      paragraphs: String(selected.description || "")
        .split("\n")
        .map(p => p.trim())
        .filter(Boolean),
    });

    // Features
    if (selected.features?.length) {
      out.push({ type: "list", title: "Características", items: selected.features });
    }

    // Advantages
    if (selected.advantages?.length) {
      out.push({ type: "cards", title: "Ventajas", items: selected.advantages });
    }

    return out;
  }, [selected]);

  const next = () => bookRef.current?.pageFlip()?.flipNext();
  const prev = () => bookRef.current?.pageFlip()?.flipPrev();

  return (
    <>
      <section className="services" id="servicios">
        <h2 id="th2">Servicios</h2>
        <br/>
        <div className="services-list">
          {services.map((s) => (
            <div
              className="service-card"
              key={s.id}
              onClick={() => setSelected(s)}
            >
              <span className="service-icon">{s.icon}</span>
              <p>{s.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Modal */}
        {selected && (
        <div
          className="modal-overlay"
          onClick={() => setSelected(null)}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <div className="modal-image">
                <img
                  src={selected.image}
                  alt={selected.name}
                  onError={(e) => {
                    // si la imagen no carga
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="modal-icon-fallback" style={{ display: 'none' }}>
                  {selected.icon}
                </div>
              </div>
              <h3>{selected.name}</h3>
              <div className="modal-nav">
                <button className="book-btn" onClick={prev} aria-label="Anterior">‹</button>
                  <span className="book-page-indicator">
                    {page + 1} / {pages.length}
                  </span>
                <button className="book-btn" onClick={next} aria-label="Siguiente">›</button>
              </div>
              <button
                className="btn-close"
                onClick={() => setSelected(null)}
              >
                ✕
              </button>
            </div>

            <div className="modal-body">
              <div className="book-wrap">
              <HTMLFlipBook
              ref={bookRef}
              width={360}
              height={500}
              size="stretch"
              minWidth={300}
              maxWidth={420}
              minHeight={420}
              maxHeight={560}
              showCover={true}
              mobileScrollSupport={true}
              onFlip={(e) => setPage(e.data)}
              className="flipbook"
              >
              {pages.map((p, idx) => (
                <div className="book-page" key={idx}>
                {p.type === "cover" && (
                  <div className="page-cover">
                  <div className="cover-img">
                  <img
                  src={p.image}
                  alt={p.title}
                  onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                  </div>
                  <div className="cover-text">
                  <h4>{p.title}</h4>
                  <p>Voltea para ver detalles</p>
                  <span className="cover-hint">Arrastra o da click para voltear</span>
                  </div>
                  </div>
                )}

                {p.type === "text" && (
                  <div className="page-body">
                  <h4>{p.title}</h4>
                  {p.paragraphs.map((t, i) => <p key={i}>{t}</p>)}
                  </div>
                )}

                {p.type === "list" && (
                  <div className="page-body">
                  <h4>{p.title}</h4>
                  <ul className="page-list">
                  {p.items.map((it, i) => <li key={i}>{it}</li>)}
                  </ul>
                  </div>
                )}

                {p.type === "cards" && (
                  <div className="page-body">
                  <h4>{p.title}</h4>
                  <div className="page-cards">
                  {p.items.map((it, i) => (
                    <div key={i} className="mini-card">
                    {it.title && <h5>{it.title}</h5>}
                    <p>{it.description}</p>
                    </div>
                  ))}
                  </div>
                  </div>
                )}
                </div>
              ))}
              </HTMLFlipBook>
              </div>
            </div>


          </div>
        </div>
      )}

      <section className="columns-section">
          <div className="columns-container">
            <div className="column-left">
              <div className="photo">
                <img
                  className="photo-serv"
                  src="/img/invisalign.jpg"
                  alt="invisalign"
                >

                </img>
              </div>
            </div>

              <div className="column-right">
              <h2 id="th2">Invisalign® — Sonríe sin brackets, con precisión digital</h2>
              <p id="pinvi">
                En Kaab Dental Experts diseñamos tu sonrisa con la tecnología más avanzada de
                alineadores transparentes Invisalign®, el sistema líder mundial que transforma tu sonrisa
                sin dolor, sin metal y sin interrumpir tu estilo de vida.

              </p>
              <p id="pinvi">
                En Kaab, la tecnología va primero:
              </p>
              <p id="pinvi">
                <ul>
               <li>Escaneo 3D: Ve tu resultado antes de empezar.</li>
               <li>Planificación Exacta: Movimiento dental preciso, estético y diseñado para tu rostro.</li>
               </ul>
              </p>
              <p id="pinvi">
                 Ventajas Inigualables:
              </p>
              <p id="pinvi">
                <ul>
               <li>Invisible: Nadie notará que los usas.</li>
               <li>Cómodo: Sin dolor ni restricciones.</li>
               <li>Predecible: Resultados garantizados por plan digital.</li>
               </ul>
              </p>
            </div>
          </div>
        </section>
    </>
  );
}
